/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRichContact } from './APIRichContact';
import {
    APIRichContactFromJSON,
    APIRichContactFromJSONTyped,
    APIRichContactToJSON,
} from './APIRichContact';

/**
 * 
 * @export
 * @interface APIPaginatedRichContactList
 */
export interface APIPaginatedRichContactList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedRichContactList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRichContactList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRichContactList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIRichContact>}
     * @memberof APIPaginatedRichContactList
     */
    results: Array<APIRichContact>;
}

/**
 * Check if a given object implements the APIPaginatedRichContactList interface.
 */
export function instanceOfAPIPaginatedRichContactList(value: object): value is APIPaginatedRichContactList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedRichContactListFromJSON(json: any): APIPaginatedRichContactList {
    return APIPaginatedRichContactListFromJSONTyped(json, false);
}

export function APIPaginatedRichContactListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedRichContactList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIRichContactFromJSON)),
    };
}

export function APIPaginatedRichContactListToJSON(value?: APIPaginatedRichContactList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIRichContactToJSON)),
    };
}

